module.exports = __webpack_public_path__ + "img/symbol_1.16319b12.png";